module.exports = __webpack_public_path__ + "img/heatexchanger.8a2d393a.svg";